<template>
  <div id="tab-user-account-list" @keydown.esc="closeAllPopup">
    
    <vs-popup fullscreen :title="$t('OrderList')" :active.sync="popupOrderList">
      <tab-user-order-list class="mt-4" :serverType="this.serverType" v-if="this.user_account_history && this.user_account_history.length > 0" :login="this.accountNo" />
        <!-- :data="user_account_history" /> -->
    </vs-popup>

    <vs-popup :title="$t('RechargeDemoAccount')" :active.sync="popupRecharge">
      <div id="Displayloading_Recharge">
        <form data-vv-scope="step-Recharge">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input disabled class="w-full" type="text" :label="$t('ServerType')" v-model="this.serverType" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input disabled class="w-full" type="text" :label="$t('Account')" v-model="this.requestAddAccountModel.account" />
            </div>
          </div>
          <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-input class="w-full" :label="$t('Amount')" v-model="requestAddAccountModel.requestDeposit" v-validate="'numeric'" name="demoDeposit"/>
              </div>
            </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click="onRechargeRequest">{{$t('Save')}}</vs-button>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>

    <vs-popup :title="$t('ChangeLeverage')" :active.sync="popupChangeLeverage">
      <div id="Displayloading_Leverage">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input disabled class="w-full" type="text" :label="$t('Leverage')" v-model="this.currentLeverage"/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <v-select
              v-model="selectedLeverag"
              :reduce="item => item.value"
              :clearable="false"
              :options="this.getMaxLeverageOptions"
              v-validate="'required'"
              name="status"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click="onChangeLeverageRequest">{{$t('Save')}}</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="$t('ChangeMTPassword')" :active.sync="popupChangePassword">
      <div id="Displayloading_Password">
        <form data-vv-scope="step-changePassword">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input disabled class="w-full" type="text" :label="$t('ServerType')" v-model="this.serverType"/>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input disabled class="w-full" :label="$t('Account')" v-model="this.accountNo"/>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-radio vs-name="Master" v-model="requestChangePasswordModel.type" vs-value="0">{{$t('ChangeMasterPassword')}}</vs-radio>
              <br />
              <vs-radio vs-name="Master" v-model="requestChangePasswordModel.type" vs-value="1" >{{$t('ChangeInverstorPassword')}}</vs-radio>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                :danger="onRequestValidate('step-changePassword.password')"
                :danger-text="errors.first('step-changePassword.password')"
                type="password"
                ref="password"
                icon-pack="feather"
                icon="icon-lock"
                name="password"
                :label="$t('NewPassword')"
                class="w-full"
                v-validate="'required|min:6|max:35'"
                v-model="requestChangePasswordModel.password"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                :danger="onRequestValidate('step-changePassword.repeatPassword')"
                :danger-text="errors.first('step-changePassword.repeatPassword')"
                type="password"
                icon-pack="feather"
                icon="icon-lock"
                :label="$t('ConfirmPassword')"
                name="repeatPassword"
                class="w-full"
                v-validate="'required|confirmed:password'"
                v-model="repeatPassword"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click="onChangePasswordRequest">{{$t('Save')}}</vs-button>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
    
    <vs-popup title="Add Account" :active.sync="popupAddAccount">
      <div id="Displayloading_AddAccount">
        <form data-vv-scope="step-addAccount">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input
                disabled
                class="w-full"
                type="text"
                label="Server Type"
                v-model="this.serverType"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <label class="vs-input--label">Account Type</label>
              <v-select
                v-model="requestAddAccountModel.mtGroup"
                :reduce="item => item.value"
                :clearable="false"
                :options="this.filterGroupList"
                v-validate="'required'"
                name="accountType"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
          </div>
          <div v-if="this.serverType ==='Demo'" class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input class="w-full mt-4" label="Deposit" v-model="requestAddAccountModel.requestDeposit" v-validate="'numeric'" name="demoDeposit"/>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button
                color="warning"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
                @click="onAddAccountRequest"
                >Add Account</vs-button
              >
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
    
    <grid-view-handler
      :usersData="usersData"
      :columnDefs="getColumnDefs"
      :cookieName="paramCookieName"
      :FloatingFilter="false"
      :isActiveColumnFilter="true"
      :isActiveOption="false"
      :isActiveSearch="true"
      :isAutoColumunDef="false"
      :isActiveBtnNew = "true"
      @onHandleActionClick="handleActionClick"
    >
    </grid-view-handler>
  </div>
</template>

<script>
import GridViewHandler from '@/views/components/grid/GridViewHandler'
import TabUserOrderList     from '@/views/components/customer-tab/Tab_User_Order_List.vue'
import { VueContext } from 'vue-context'
import vSelect from 'vue-select'
// Store Module
import moduleMt4Management from '@/store/mt4-management/moduleMt4Management.js'
import moduleMt5Management from '@/store/mt5-management/moduleMt5Management.js'
import moduleCustomManagment from '@/store/custom-managment/moduleCustomManagment.js'
import moduleTransactionMng from '@/store/transaction-mng/moduleTransactionMng.js'

export default {
  components: {
    GridViewHandler,
    TabUserOrderList,
    VueContext,
    vSelect
  },
  props: {
    userName: {
      type: String,
      required: true,
      default:'Real'
    },
    serverType: {
      type: String,
      required: true,
      default:'Real'
    }
  },
  data () {
    return {
      cellRenderData: {},
      cellRenderAction: false,
      selectedLeverag: 10,
      currentLeverage: 0,
      maxLeverage: 1000,
      leverageOptins: [
        {value: 10, label: '1 : 10'},
        {value: 100, label: '1 : 100'},
        {value: 200, label: '1 : 200'},
        {value: 300, label: '1 : 300'},
        {value: 400, label: '1 : 400'},
        {value: 500, label: '1 : 500'},
        {value: 800, label: '1 : 800'},
        {value: 1000, label: '1 : 1000'}
      ],
      requestChangeLeverageModel:{
        Logins: [0],
        ServerType: '',
        Len: 1,
        Command: 3,
        Leverage: 10
      },
      requestChangePasswordModel:{
        login: 0,
        password: '',
        serverType: '',
        type: 0
      },
      requestAddAccountModel:{
        customerId: 0,
        requestDeposit: 1000,
        mtGroup:'',
        serverType: '',
        account: -1
      },
      groupList: [],
      repeatPassword: '',
      popupOrderList: false,
      popupChangeLeverage: false,
      popupChangePassword: false,
      popupAddAccount: false,
      popupRecharge: false,
      accountNo: -1,
      user_account_history: null,
      data_local: [],
      gridApi: null,
      gridOptions: {},
      payload: {email: null, server: this.serverType},

      columnDefs: [],
      paramCookieName: 'CustomerAccountList'
    }
  },
  methods:{
    closeAllPopup () {
      this.popupOrderList = false
      this.popupChangeLeverage = false
      this.popupChangePassword = false
      this.popupAddAccount = false
      this.popupRecharge = false
    },
    handleActionClick (action) {
      if (action === 'New') {
        this.openAddAccountPopup()
      }
    },
    fetch_user_data (userName, server) {
      this.payload.email =  userName
      this.payload.server =  server
      this.$store.dispatch('TransactionMng/fetchUserAccountsByEmail', this.payload)
        .then(res => { 
          this.data_local = res.data.data
          this.popupChangeLeverage = false
        })
        .catch(err => {
          console.error(err) 
        })
    },

    optionClicked (text) {
      this.$vs.notify({
        title: 'Action Clicked',
        text,
        icon: 'feather',
        iconPack: 'icon-alert-circle',
        color: 'primary'
      })
    },
    validateChangePassword () {
      this.$validator.validateAll('step-changePassword').then(result => {
        if (result) {
          alert('Form submitted!')
        } else {
          alert('Form not submitted!')
        }
      })
    },

    onChangeLeverageRequest () {
      this.$vs.dialog({
        color: 'danger',
        title: 'Confirm',
        text: 'Are you Sure?',
        accept: this.onChangeLeverageRequestData
      })
      
    },
    onChangeLeverageRequestData () {
      this.requestChangeLeverageModel.Logins[0] = this.accountNo
      this.requestChangeLeverageModel.ServerType = this.serverType
      this.requestChangeLeverageModel.Leverage = this.selectedLeverag

      this.$store.dispatch('TransactionMng/UsersGroupOp', this.requestChangeLeverageModel)
        .then(() => {
          this.$vs.notify({
            title: 'Change Leverage',
            text: 'Leverage Changed Successfully',
            icon: 'feather',
            iconPack: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Change Leverage',
            text: 'Leverage Not Changed',
            icon: 'feather',
            iconPack: 'icon-alert-circle',
            color: 'danger'
          }) 
        })
      setTimeout(() => (this.popupChangeLeverage = false), 300)
      setTimeout(() => this.fetch_user_data(this.userName, this.serverType), 500)
    },

    onChangePasswordRequest () {
      this.$validator.validateAll('step-changePassword').then(result => {
        if (result) {
          this.$vs.dialog({
            color: 'danger',
            title: 'Confirm',
            text: 'Are you Sure?',
            accept: this.onChangePasswordRequestData
          })
        }
      })
    },

    onChangePasswordRequestData () {

      this.requestChangePasswordModel.login = this.accountNo
      this.requestChangePasswordModel.serverType = this.serverType === 'Demo' ? 0 : 1
      
      console.error(this.requestChangePasswordModel.password);

      this.$store.dispatch('Mt5Management/UserPasswordChange', this.requestChangePasswordModel)
        .then(() => {
          this.$vs.notify({
            title: 'Change Password',
            text: 'Password Changed Successfully',
            icon: 'feather',
            iconPack: 'icon-alert-circle',
            color: 'success'
          })            
        }).catch(() => {
          this.$vs.notify({
            title: 'Change Password',
            text: 'Password Not Changed',
            icon: 'feather',
            iconPack: 'icon-alert-circle',
            color: 'danger'
          }) 
        })
      setTimeout(() => (this.popupChangePassword = false), 300)
      setTimeout(() => this.fetch_user_data(this.userName, this.serverType), 500)
    },
    
    onAddAccountRequest () {
      this.$validator.validateAll('step-addAccount').then(result => {
        
        if (result) {
          this.$vs.loading({
            container: '#Displayloading_AddAccount',
            type: 'material',
            scale: 1
          })    

          this.requestAddAccountModel.customerId = this.$store.state.AppActiveUser.customerId
          this.requestAddAccountModel.serverType = this.serverType
          //this.requestAddAccountModel.mtGroup = 'real\\fast\\std'

          this.$store.dispatch('TransactionMng/addMt5Account', this.requestAddAccountModel)
            .then(res => {

              console.error(res)
              this.$vs.loading.close('#Displayloading_AddAccount > .con-vs-loading')
              this.popupAddAccount = false
              this.fetch_user_data(this.userName, this.serverType)
              // if (res.Data.status_code === '0') {
              //   this.$vs.notify({
              //     title: 'change password',
              //     text: 'successful change password',
              //     icon: 'feather',
              //     iconPack: 'icon-alert-circle',
              //     color: 'success'
              //   })            
              //   this.popupChangePassword = false
              // } else {
              //   this.$vs.notify({
              //     title: 'change password',
              //     text: res.Data.status_message,
              //     icon: 'feather',
              //     iconPack: 'icon-alert-circle',
              //     color: 'warning'
              //   })                 
              // }
            })
            .catch(() => {
              this.$vs.loading.close('#Displayloading_AddAccount > .con-vs-loading')
            })
        }
      })
    },    

    onRechargeRequest () {
      this.$validator.validateAll('step-Recharge').then(result => {
        if (result) {
          this.$vs.dialog({
            color: 'danger',
            title: 'Confirm',
            text: 'Are you Sure?',
            accept: this.UpdateBalanceData
          })
        }
      })
    },
    UpdateBalanceData () {
      this.requestAddAccountModel.customerId = this.$store.state.AppActiveUser.customerId
      this.requestAddAccountModel.serverType = this.serverType

      this.$store.dispatch('TransactionMng/rechargeMt4DemoAccount', this.requestAddAccountModel)
        .then(res => {
          this.$vs.notify({
            title: 'Success',
            text: 'Customer Balance Added Successfully',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check-circle'
          })
              
          console.error(res)
          this.popupRecharge = false
          setTimeout(() => this.fetch_user_data(this.userName, this.serverType), 500)
        })
        .catch(err => {
          this.$vs.notify({
            title: 'Error',
            text: 'Customer Balance Not Added',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check-circle'
          })
          setTimeout(() => (this.popupRecharge = false), 500)
        })
    },
    
    openAddAccountPopup () {
      this.groupList = this.$store.state.CustomManagment.groups
      this.popupAddAccount = true
      this.requestAddAccountModel.mtGroup = this.filterGroupList[0].value
    }
  },
  computed: {
    getColumnDefs () {
      return [
        {
          headerName: this.$t('AccountId'),
          i18n:this.$t('AccountId'),
          field: 'Login',
          headerCheckboxSelection: false,
          headerCheckboxSelectionFilteredOnly: false,
          filter: true,
          width: 100,
          hide: false,
          icon: 'icon-book-open',
          color: 'primary',
          buttonType: 'border',
          cellRendererFramework: 'genericCellRendererButton'
        },
        {
          headerName: '',
          field: 'CHANGEPASSWORD',
          width: 50,
          fixValue: ' ',
          icon: 'icon-lock',
          color: 'danger',
          buttonType: 'border',
          cellRendererFramework: 'genericCellRendererButton'
        },
        {
          headerName: this.$t('Name'),
          i18n:this.$t('Name'),
          field: 'Name',
          width: 150,
          hide: false,
          cellRendererFramework: 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Group'),
          i18n: this.$t('Group'),
          field: 'Group',
          width: 100,
          hide: false,
          valueFormatter: getGroupTitle,
          cellRendererFramework: 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Balance'),
          i18n:this.$t('Balance'),
          field: 'Balance',
          width: 130,
          hide: false,
          valueFormatter: currencyFormatter,
          icon: 'icon-dollar-sign',
          color: 'primary',
          buttonType: 'border',
          cellRendererFramework: 'genericCellRendererButton'
        },
        {
          headerName: this.$t('Equity'),
          i18n:this.$t('Equity'),
          field: 'Equity',
          width: 120,
          hide: false,
          valueFormatter: currencyFormatterWithDollar,
          cellRendererFramework: 'genericCellRendererContent'
        },
        {
          headerName: this.$t('Margin'),
          i18n:this.$t('Margin'),
          field: 'Margin',
          width: 120,
          hide: false,
          valueFormatter: currencyFormatterWithDollar
        },
        {
          headerName: this.$t('MarginLevel'),
          i18n:this.$t('MarginLevel'),
          field: 'Margin_Level',
          width: 150,
          hide: false,
          valueFormatter: percentFormatter,
          cellRendererFramework: 'genericCellRendererContent'
        },
        {
          headerName: this.$t('MarginFree'),
          i18n:this.$t('MarginFree'),
          field: 'Margin_Free',
          width: 150,
          hide: false,
          valueFormatter: currencyFormatterWithDollar
        },
        {
          headerName: this.$t('Leverage'),
          i18n:this.$t('Leverage'),
          field: 'Leverage',
          width: 100,
          icon: 'icon-shuffle',
          color: 'primary',
          buttonType: 'border',
          cellRendererFramework: 'genericCellRendererButton'
        },
        {
          headerName: 'Agent',
          field: 'Agent_Account',
          width: 150,
          hide: true
        },
        {
          headerName: 'Phone',
          field: 'Phone',
          width: 150,
          valueFormatter: hideMobile,
          hide: true
        },
        {
          headerName: 'Email',
          field: 'Email',
          width: 200,
          hide: true
        },
        {
          headerName: 'Register Date',
          field: 'RegDate',
          width: 180,
          hide: true,
          valueFormatter: dateFormatter
        },
        {
          headerName: 'Last Data',
          field: 'LastDate',
          width: 180,
          hide: true,
          valueFormatter: dateFormatter
        },
        {
          headerName: 'Modify Date',
          field: 'ModifyTime',
          width: 180,
          hide: true,
          valueFormatter: dateFormatter
        },
        {
          headerName: this.$t('Comment'),
          i18n:this.$t('Comment'),
          field: 'Comment',
          width: 200,
          hide: false
        },
        {
          headerName: 'Country',
          field: 'Country',
          width: 150,
          hide: true
        },
        {
          headerName: 'City',
          field: 'City',
          width: 150,
          hide: true
        },
        {
          headerName: 'Address',
          field: 'Address',
          width: 300,
          hide: true
        },
        {
          headerName: 'Zip code',
          field: 'ZipCode',
          width: 140,
          hide: true
        },
        {
          headerName: 'State',
          field: 'State',
          width: 150,
          hide: true
        },
        {
          headerName: 'Status',
          field: 'Status',
          width: 100,
          hide: true
        },
        {
          headerName: 'MQId',
          field: 'MQID',
          width: 100,
          hide: true
        },
        // {
        //   headerName: 'Enable',
        //   field: 'ENABLE',
        //   width: 80,
        //   hide: true,
        //   contentType: 'chip',
        //   contentOptions: [{value: 0, chipText: 'Disable', chipColor: 'warning'}, {value: 1, chipText: 'Enable', chipColor: 'success'}],
        //   cellRendererFramework: 'genericCellRendererContent'
        // },
        {
          headerName: 'Enable Change Pass',
          field: 'Enable_Change_Pass',
          width: 200,
          hide: true
        },
        {
          headerName: 'Enable Readonly',
          field: 'Enable_ReadOnly',
          width: 200,
          hide: true
        },
        // {
        //   headerName: 'Enable Opt',
        //   field: 'ENABLE_OPT',
        //   width: 150,
        //   hide: true
        // },
        {
          headerName: 'Password Phone',
          field: 'Password_Phone',
          width: 200,
          hide: true
        },
        // {
        //   headerName: 'Lead Source',
        //   field: 'LEAD_SOURCE',
        //   width: 150,
        //   hide: true
        // },
        {
          headerName: 'Time Stamp',
          field: 'TimeStamp',
          width: 150,
          hide: true
        },
        {
          headerName: 'Prev Month Balance',
          field: 'PrevMonthBalance',
          width: 200,
          hide: true
        },
        {
          headerName: 'Prev Balance',
          field: 'PrevBalance',
          width: 150,
          hide: true
        },
        {
          headerName: 'Credit',
          field: 'Credit',
          width: 100,
          hide: true
        },
        {
          headerName: 'Interestrate',
          field: 'InterestRate',
          width: 150,
          hide: true
        },
        {
          headerName: 'Taxes',
          field: 'Taxes',
          width: 100,
          hide: true
        },
        {
          headerName: 'Send Reports',
          field: 'Send_Reports',
          width: 150,
          hide: true
        },
        {
          headerName: 'User Color',
          field: 'User_Color',
          width: 130,
          hide: true
        },
        {
          headerName: 'Currency',
          field: 'Currency',
          width: 120,
          hide: true
        },
        {
          headerName: 'Id',
          field: 'ID',
          width: 100,
          hide: true
        }
      ]
    },
    validateForm () {
      return !this.errors.any()
    },
    usersData () {
      return this.data_local
    },
    onRequestValidate () {
      return (value) => {
        return true
        // return (this.errors.has(value))
      }
    },
    filterGroupList () {
      return this.groupList.filter(f => f.isBase && f.isReal === (this.serverType === 'Real')).map(
        (item) => { 
          return {
            label: item.groupTitle,
            value: item.mtGroupName
          }
        })
    },
    getMaxLeverageOptions () {
      return this.leverageOptins.filter(f => f.value <= this.maxLeverage)
    }
    
  },
  created () {
    if (!moduleMt4Management.isRegistered) {
      this.$store.registerModule('Mt4Management', moduleMt4Management)
      moduleMt4Management.isRegistered = true
    }
    if (!moduleMt5Management.isRegistered) {
      this.$store.registerModule('Mt5Management', moduleMt5Management)
      moduleMt5Management.isRegistered = true
    }
    if (!moduleCustomManagment.isRegistered) {
      this.$store.registerModule('CustomManagment', moduleCustomManagment)
      moduleCustomManagment.isRegistered = true
    }
    if (!moduleTransactionMng.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionMng)
      moduleTransactionMng.isRegistered = true
    }

    this.fetch_user_data(this.userName, this.serverType)
    this.$store.dispatch('CustomManagment/getAllGroups')
  },

  watch: {
    popupOrderList (newVal) {
      if (newVal) {
        const d = new Date(Date.now())
        

        this.payload.client =  this.accountNo
        this.payload.end = '2021-09-07'
        // this.payload.end = `${ d.getFullYear() }-${  (`0${d.getMonth() + 1}`).slice(-2)  }-${ (`0${  d.getDate()}`).slice(-2)  }`
        this.payload.start = `${ d.getFullYear() }-${  (`0${d.getMonth() }`).slice(-2)  }-${ (`0${  d.getDate()}`).slice(-2)  }`
        
        this.payload.server =  this.serverType

        this.$store.dispatch('Mt5Management/fetchClientHistory', this.payload)
          .then(res => {
            this.user_account_history = res.data.Data
            // console.error(this.user_account_history)
          })
      } else this.user_account_history = null
    },
    cellRenderAction (newVal) {
      if (newVal) {
        if (this.cellRenderData.column.colDef.field === 'Leverage') {
          this.accountNo = this.cellRenderData.data.Login
          this.currentLeverage = this.cellRenderData.value
          this.selectedLeverag = this.cellRenderData.value
          this.maxLeverage = this.$store.state.CustomManagment.groups.filter(f => f.mtGroupName === this.cellRenderData.data.Group).length ? this.$store.state.CustomManagment.groups.filter(f => f.mtGroupName === this.cellRenderData.data.Group)[0].maxLeverage : 10
          this.popupChangeLeverage = true
        } else if (this.cellRenderData.column.colDef.field === 'Balance') {
          if (this.serverType === 'Real') {
            this.$router.push({ name: 'makeDeposit'})
          } else {
            this.requestAddAccountModel.account = this.cellRenderData.data.Login
            this.requestAddAccountModel.requestDeposit = 1000
            this.popupRecharge = true
          }
        } else if (this.cellRenderData.column.colDef.field === 'Login') {
          this.accountNo = this.cellRenderData.data.Login
          this.popupOrderList = true
        } else if (this.cellRenderData.column.colDef.field === 'CHANGEPASSWORD') {
          this.accountNo = this.cellRenderData.data.Login
          this.requestChangePasswordModel.password = ''
          this.repeatPassword = ''
          this.popupChangePassword = true
        }
        this.cellRenderAction = false
      } 
    }
  }
}
</script>

<style>
.vs-popup  #Displayloading_Leverage{
  height: 300px;
}
  .con-vs-dialog {
    z-index: 54000;
} 
</style>